// Shared panel styling. Plain sx objects, not a wrapper component, because
// `react/no-multi-comp` allows only one component per file.

/** Outer white card that wraps a panel. */
export const CARD_SX = {
  backgroundColor: "background.paper",
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 1,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  minWidth: 0,
  padding: 3
} as const;

/** Panel heading with the rule underneath it. */
export const PANEL_HEADING_SX = {
  borderBottom: "1px solid",
  borderColor: "divider",
  paddingBottom: 0.5
} as const;

/** Recessed grey group that holds a label + field row. */
export const FIELD_GROUP_SX = {
  backgroundColor: "grey.100",
  border: "1px solid",
  borderColor: "grey.200",
  borderRadius: 1,
  minWidth: 0,
  padding: 2
} as const;

/** Wraps each matched substring inside the JSON preview when searching. */
export const SEARCH_MATCH_SX = {
  backgroundColor: "grey.400",
  borderRadius: "2px",
  fontWeight: 600
} as const;

// Fixed height, not maxHeight, so the panel doesn't jump while filtering.
export const CODE_BLOCK_SX = {
  backgroundColor: "grey.100",
  border: "1px solid",
  borderColor: "grey.200",
  borderRadius: 1,
  color: "text.primary",
  fontFamily: "monospace",
  fontSize: "0.8125rem",
  height: "350px",
  lineHeight: 1.6,
  overflow: "auto",
  padding: 2,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word"
} as const;
